'use strict';

exports.__esModule = true;
var FILE = '__NATIVE_FILE__';
exports.FILE = FILE;
var URL = '__NATIVE_URL__';
exports.URL = URL;
var TEXT = '__NATIVE_TEXT__';
exports.TEXT = TEXT;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd-html5-backend/lib/NativeTypes.js
 ** module id = 353
 ** module chunks = 0
 **/